module.exports = __webpack_public_path__ + "static/movement_trace-06c8e23ef796c3b6613f280951217a59.png";